import React from "react";
import AdminCatalogsRoutes from "./AdminCatalogsRoutes";

import { useTracking } from "react-tracking";
import { useDispatch, useSelector } from "react-redux";
import { startRegisterTrackingHistory } from "../../app/actions/trackingHistoryActions";

const AdminCatalogsScreen = () => {
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.auth);

  const { Track } = useTracking(
    {
      module: "Administration Catalog",
      page: "Admin Catalog Screen",
      user_id: user.user_id,
      user_name: user.user_name,
      
    },
    {
      dispatch: (data) => {

        dispatch(startRegisterTrackingHistory(data));
        
      },
    }
  );

  return (
    <div>
      <Track>
        <AdminCatalogsRoutes />
      </Track>
    </div>
  );
};

export default AdminCatalogsScreen;
